<script>
  import Vue from 'vue'
  import { base64UrlDecode } from 'vtils'
  import { redirectTo, router } from '@/router'

  export default Vue.extend({
    created() {
      const { __q__: q, ...restQuery } = router.currentRoute.query
      const payload = JSON.parse(base64UrlDecode(q))
      const query = {
        ...payload.params,
        ...restQuery,
      }
      const name = payload.name || query._
      redirectTo(name, query)
    },

    render() {
      return null
    },
  })
</script>
